import { render, staticRenderFns } from "./addressSet.vue?vue&type=template&id=6667d132&scoped=true&"
import script from "./addressSet.vue?vue&type=script&lang=js&"
export * from "./addressSet.vue?vue&type=script&lang=js&"
import style0 from "./addressSet.css?vue&type=style&index=0&id=6667d132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6667d132",
  null
  
)

export default component.exports